<template>
    <div class="approval-box">
        <ul class="approval-list">
            <li class="approval-item" :class="type == '' ? 'active' : ''" @click="handleActive('')">
                <p class="approval-amount"><span>{{ boxData.all }}</span>item(s)</p>
                <span class="approval-note">All</span>
            </li>
            <li class="approval-item" :class="type == 'Open' ? 'active' : ''" @click="handleActive('Open')">
                <p class="approval-amount"><span>{{ boxData.open }}</span>Case(s)</p>
                <span class="approval-note">Open</span>
            </li>
            <li class="approval-item" :class="type == 'Assigned' ? 'active' : ''" @click="handleActive('Assigned')">
                <p class="approval-amount"><span>{{ boxData.assigned }}</span>Case(s)</p>
                <span class="approval-note">Assigned</span>
            </li>
            <li class="approval-item" :class="type == 'PIC Acknowledged' ? 'active' : ''" @click="handleActive('PIC Acknowledged')">
                <p class="approval-amount"><span>{{ boxData.pic_acknowledged }}</span>Case(s)</p>
                <span class="approval-note">PIC Acknowledged</span>
            </li>
            <li class="approval-item" :class="type == 'On Site' ? 'active' : ''" @click="handleActive('On Site')">
                <p class="approval-amount"><span>{{ boxData.on_site }}</span>Case(s)</p>
                <span class="approval-note">On Site</span>
            </li>
            <li class="approval-item" :class="type == 'Repeated Feedback' ? 'active' : ''" @click="handleActive('Repeated Feedback')">
                <p class="approval-amount"><span>{{ boxData.repeated_feedback }}</span>Case(s)</p>
                <span class="approval-note">Repeated Feedback</span>
            </li>
            <li class="approval-item" :class="type == 'RWO Issued' ? 'active' : ''" @click="handleActive('RWO Issued')">
                <p class="approval-amount"><span>{{ boxData.rwo_issued }}</span>Case(s)</p>
                <span class="approval-note">RWO Issued</span>
            </li>
            <li class="approval-item" :class="type == 'Completed' ? 'active' : ''" @click="handleActive('Completed')">
                <p class="approval-amount"><span>{{ boxData.completed }}</span>Case(s)</p>
                <span class="approval-note">Completed</span>
            </li>
            <li class="approval-item" :class="type == 'Cancelled' ? 'active' : ''" @click="handleActive('Cancelled')">
                <p class="approval-amount"><span>{{ boxData.cancelled }}</span>Case(s)</p>
                <span class="approval-note">Cancelled</span>
            </li>
            <li class="approval-item" :class="type == 'Closed' ? 'active' : ''" @click="handleActive('Closed')">
                <p class="approval-amount"><span>{{ boxData.closed }}</span>Case(s)</p>
                <span class="approval-note">Closed</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'case-box',
        data() {
            return {
                type: '',
                boxData: {
                    all:0,
                    assigned:0,
                    open:0,
                    pic_acknowledged:0,
                    on_site:0,
                    repeated_feedback:0,
                    rwo_issued:0,
                    completed:0,
                    cancelled:0,
                    closed:0,
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && old || !val)
                    this.getCountCase()
            }
        },
        created() {
            this.getCountCase();
        },
        methods: {
            getCountCase() {
                this.$store.dispatch(`CaseManagementController/getCountCase`, {
                    client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null
                })
                .then(result => {
                    this.boxData = Object.assign(this.boxData, result)
                })
            },
            handleActive(type_selected) {
                this.type = type_selected;
                this.$emit('selectedType', this.type);
            }
        }
    }
</script>